<template>
    <client-page-full-page class="app--main">

        <full-page ref="fullpage" :options="options" id="fullpage">

            <div class="fullpage-section fullpage-section--visual">
                <div class="visual">
                    <div class="swiper-container">
                        <div class="swiper-wrapper">

                            <!-- S--기업소개 -->
                            <div class="swiper-slide">
                                <div class="swiper-slide__inner">
                                    <div class="visual__con">
                                        <div class="text-ani-wrap">
                                            <div class="text-ani">
                                                <h2 class="font-weight-thin">세계를 무대로</h2>
                                            </div>
                                            <div class="text-ani">
                                                <h2>세일즈&구독대행 서비스를</h2>
                                            </div>
                                            <div class="text-ani">
                                                <h2 class="font-weight-thin">선도합니다.</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="swiper-slide__bg">
                                        <video playsinline muted poster="/images/main/visual/v1-thumb.jpg" class="swiper-slide__bg__video">
                                            <source src="/images/main/visual/v1.mp4" type="video/mp4">
                                            <strong>웹 브라우저가 video를 지원하지 않습니다.</strong>
                                        </video>
                                    </div> -->
                                    <div v-if="!!mainVisual1Url" class="swiper-slide__bg">
                                        <video playsinline muted :key="mainVisual1Url" class="swiper-slide__bg__video">
                                            <source :src="mainVisual1Url" type="video/mp4">
                                            <strong>웹 브라우저가 video를 지원하지 않습니다.</strong>
                                        </video>
                                    </div>
                                    <div v-else class="swiper-slide__bg">
                                        <video playsinline muted :poster=mainVisual1Poster :key="mainVisual1Url" class="swiper-slide__bg__video swiper-slide__bg__image">
                                            <source :src="mainVisual1Url" type="video/mp4">
                                            <strong>웹 브라우저가 video를 지원하지 않습니다.</strong>
                                        </video>
                                    </div>
                                </div>
                            </div>
                            <!-- E--기업소개 -->

                            <!-- S--사업소개 -->
                            <div class="swiper-slide">
                                <div class="swiper-slide__inner">
                                    <div class="visual__con">
                                        <div class="text-ani-wrap">
                                            <div class="text-ani">
                                                <h2 class="font-weight-thin">맞춤형 대면 서비스로</h2>
                                            </div>
                                            <div class="text-ani">
                                                <h2>영업의 한계를 넘습니다.</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="swiper-slide__bg">
                                        <video playsinline muted poster="/images/main/visual/v2-thumb.jpg" class="swiper-slide__bg__video">
                                            <source src="/images/main/visual/v2.mp4" type="video/mp4">
                                            <strong>웹 브라우저가 video를 지원하지 않습니다.</strong>
                                        </video>
                                    </div> -->
                                    <div v-if="!!mainVisual2Url" class="swiper-slide__bg">
                                        <video playsinline muted :key="mainVisual2Url" class="swiper-slide__bg__video">
                                            <source :src="mainVisual2Url" type="video/mp4">
                                            <strong>웹 브라우저가 video를 지원하지 않습니다.</strong>
                                        </video>
                                    </div>
                                    <div v-else class="swiper-slide__bg">
                                        <video playsinline muted :poster=mainVisual2Poster :key="mainVisual2Url" class="swiper-slide__bg__video swiper-slide__bg__image">
                                            <source :src="mainVisual2Url" type="video/mp4">
                                            <strong>웹 브라우저가 video를 지원하지 않습니다.</strong>
                                        </video>
                                    </div>
                                </div>
                            </div>
                            <!-- E--사업소개 -->

                            <!-- S--브랜드홍보대사 -->
                            <div class="swiper-slide">
                                <div class="swiper-slide__inner">
                                    <div class="visual__con">
                                        <div class="text-ani-wrap">
                                            <div class="text-ani">
                                                <h2 class="font-weight-thin">공감을 통해</h2>
                                            </div>
                                            <div class="text-ani">
                                                <h2>브랜드 경험을 선사합니다.</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="swiper-slide__bg">
                                        <video playsinline muted poster="/images/main/visual/v3-thumb.jpg" class="swiper-slide__bg__video">
                                            <source src="/images/main/visual/v3.mp4" type="video/mp4">
                                            <strong>웹 브라우저가 video를 지원하지 않습니다.</strong>
                                        </video>
                                    </div> -->
                                    <div v-if="!!mainVisual3Url" class="swiper-slide__bg">
                                        <video playsinline muted :key="mainVisual3Url" class="swiper-slide__bg__video">
                                            <source :src="mainVisual3Url" type="video/mp4">
                                            <strong>웹 브라우저가 video를 지원하지 않습니다.</strong>
                                        </video>
                                    </div>
                                    <div v-else class="swiper-slide__bg">
                                        <video playsinline muted :poster=mainVisual3Poster :key="mainVisual3Url" class="swiper-slide__bg__video swiper-slide__bg__image">
                                            <source :src="mainVisual3Url" type="video/mp4">
                                            <strong>웹 브라우저가 video를 지원하지 않습니다.</strong>
                                        </video>
                                    </div>
                                </div>
                            </div>
                            <!-- E--브랜드홍보대사 -->

                            <!-- S--펀드레이저 -->
                            <div class="swiper-slide">
                                <div class="swiper-slide__inner">
                                    <div class="visual__con">
                                        <div class="text-ani-wrap">
                                            <div class="text-ani">
                                                <h2 class="font-weight-thin">진심을 통해</h2>
                                            </div>
                                            <div class="text-ani">
                                                <h2>마음을 모으고 움직입니다.</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="swiper-slide__bg">
                                        <div class="swiper-slide__bg__image" style="background-image: url(/images/main/visual/v4.jpg);"></div>
                                    </div> -->
                                    <div v-if="!!mainVisual4Url" class="swiper-slide__bg">
                                        <video playsinline muted :key="mainVisual4Url" class="swiper-slide__bg__video">
                                            <source :src="mainVisual4Url" type="video/mp4">
                                            <strong>웹 브라우저가 video를 지원하지 않습니다.</strong>
                                        </video>
                                    </div>
                                    <div v-else class="swiper-slide__bg">
                                        <video playsinline muted :poster=mainVisual4Poster :key="mainVisual4Url" class="swiper-slide__bg__video swiper-slide__bg__image">
                                            <source :src="mainVisual4Url" type="video/mp4">
                                            <strong>웹 브라우저가 video를 지원하지 않습니다.</strong>
                                        </video>
                                    </div>
                                </div>
                            </div>
                            <!-- E--펀드레이저 -->

                        </div>
                        <div class="swiper-control">
                            <div class="visual-pagination"></div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="fullpage-section fullpage-section--services">
                <div class="fullpage-inner">
                    <v-container>
                        <div class="section-tit text-center mb-50">
                            <h2 class="font-size-32 font-size-md-46 font-size-lg-60 font-weight-bold color-white line-height-1" data-aos="fade-down">
                                Our Services
                            </h2>
                            <p class="color-grey-d mt-8 mt-lg-20 font-size-14 font-size-lg-18" data-aos="fade-up">
                                영업 실적은 물론, 브랜드의 가치까지 전달합니다.
                            </p>
                        </div>
                        <div class="service-slide">
                            <div class="swiper-container">
                                <v-btn x-large icon outlined color="black" class="slide-btn slide-btn-next"><i class="icon icon-right-arrow"></i></v-btn>
                                <v-btn x-large icon outlined color="black" class="slide-btn slide-btn-prev"><i class="icon icon-left-arrow"></i></v-btn>
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <div class="service-item-wrap">
                                            <div class="service-item">
                                                <div class="service-item-inner">
                                                    <div class="service-item__top">
                                                        <h4 class="font-weight-bold line-height-1">
                                                            Commercial
                                                        </h4>
                                                        <p>
                                                            대면 영업을 통해 국내외 제품을 <br class="d-none d-lg-block">
                                                            홍보하고 판매합니다.
                                                        </p>
                                                    </div>
                                                    <div class="service-item__icon">
                                                        <div class="service-item__icon-wrap">
                                                            <img src="/images/main/service-icon1.svg" alt="" class="d-block icon-view">
                                                            <img src="/images/main/service-icon1-on.svg" alt="" class="d-block icon-hover">
                                                        </div>
                                                    </div>
                                                    <div class="service-item__bottom">
                                                        <p>
                                                            영업 전문가인 브랜드 홍보대사의 대면 영업을 <br class="d-none d-lg-block">
                                                            통해 잠재고객 한 명 한 명에게 맞춤형 홍보 및 <br class="d-none d-lg-block">
                                                            판매가 가능합니다.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="swiper-slide">
                                        <div class="service-item-wrap">
                                            <div class="service-item">
                                                <div class="service-item-inner">
                                                    <div class="service-item__top">
                                                        <h4 class="font-weight-bold line-height-1">
                                                            Subscription
                                                        </h4>
                                                        <p>
                                                            고객사의 서비스를 홍보하고 <br class="d-none d-lg-block">
                                                            구독자를 확보합니다.
                                                        </p>
                                                    </div>
                                                    <div class="service-item__icon">
                                                        <div class="service-item__icon-wrap">
                                                            <img src="/images/main/service-icon2.svg" alt="" class="d-block icon-view">
                                                            <img src="/images/main/service-icon2-on.svg" alt="" class="d-block icon-hover">
                                                        </div>
                                                    </div>
                                                    <div class="service-item__bottom">
                                                        <p>
                                                            다양한 국가에서 25년 이상 축적한 경험과 <br class="d-none d-lg-block">
                                                            노하우를 바탕으로 구독 서비스 홍보, 구독자 <br class="d-none d-lg-block">
                                                            확보를 전문적으로 대행합니다.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="swiper-slide">
                                        <div class="service-item-wrap">
                                            <div class="service-item">
                                                <div class="service-item-inner">
                                                    <div class="service-item__top">
                                                        <h4 class="font-weight-bold line-height-1">
                                                            Fundraising
                                                        </h4>
                                                        <p>
                                                            NGO 단체 후원자를 <br class="d-none d-lg-block">
                                                            유치합니다.
                                                        </p>
                                                    </div>
                                                    <div class="service-item__icon">
                                                        <div class="service-item__icon-wrap">
                                                            <img src="/images/main/service-icon3.svg" alt="" class="d-block icon-view">
                                                            <img src="/images/main/service-icon3-on.svg" alt="" class="d-block icon-hover">
                                                        </div>
                                                    </div>
                                                    <div class="service-item__bottom">
                                                        <p>
                                                            펀드레이징 전문 브랜드인 서포트웍스를 통해 <br class="d-none d-lg-block">
                                                            전문 펀드레이저와 함께 NGO의 가치와 의미를 <br class="d-none d-lg-block">
                                                            전달하고 후원자를 유치합니다. 
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-container>
                </div>
            </div>

            <div class="fullpage-section fullpage-section--company">
                <div class="fullpage-inner">
                    <v-container>
                        <v-row>
                            <v-col cols="12" lg="3" class="mb-38 mb-lg-0">
                                <p class="color-point font-size-14 font-size-lg-18 line-height-1 mb-8 mb-lg-22">
                                    SalesWorks Korea
                                </p>
                                <h4 class="font-size-22 font-size-lg-36 font-weight-bold line-height-13">
                                    함께, 더 멀리 <br class="d-none d-lg-block">
                                    모두를 위한 기회를 <br class="d-none d-lg-block">
                                    만듭니다.
                                </h4>
                            </v-col>
                            <v-col cols="12" lg="9">
                                <v-row class="pl-xl-42 pt-lg-48" justify="center">
                                    <v-col cols="6" sm="4">
                                        <div class="icon-img-box-wrap w-100" data-aos="fade-right">
                                            <div class="icon-img-box">
                                                <v-img src="/images/main/company-icon1.svg" max-width="48" class="icon-img-box__icon icon-img-box__icon--on"></v-img>
                                                <v-img src="/images/main/company-icon1-dark.svg" max-width="48" class="d-none d-lg-block icon-img-box__icon icon-img-box__icon--dark"></v-img>
                                                <div class="image w-100">
                                                    <img src="/images/main/company-img1.png" alt="" class="d-block w-100">
                                                </div>
                                            </div>
                                            <div class="count-txt mt-n34 px-16 px-md-26 w-100 text-right">
                                                <h2 class="font-size-32 font-size-md-46 font-size-lg-60 line-height-1 font-weight-bold color-point mb-6 mb-lg-10">
                                                    1995
                                                </h2>
                                                <p class="font-size-14 font-size-lg-18">
                                                    설립
                                                </p>
                                            </div>
                                        </div>
                                    </v-col>
                                    <v-col cols="6" sm="4">
                                        <div class="icon-img-box-wrap w-100" data-aos="fade-right" data-aos-delay="200">
                                            <div class="icon-img-box">
                                                <v-img src="/images/main/company-icon2.svg" max-width="48" class="icon-img-box__icon icon-img-box__icon--on"></v-img>
                                                <v-img src="/images/main/company-icon2-dark.svg" max-width="48" class="d-none d-lg-block icon-img-box__icon icon-img-box__icon--dark"></v-img>
                                                <div class="image w-100">
                                                    <img src="/images/main/company-img2.png" alt="" class="d-block w-100">
                                                </div>
                                            </div>
                                            <div class="count-txt mt-n34 px-16 px-md-26 w-100 text-right">
                                                <h2 class="font-size-32 font-size-md-46 font-size-lg-60 line-height-1 font-weight-bold color-point mb-6 mb-lg-10">
                                                    8+
                                                </h2>
                                                <p class="font-size-14 font-size-lg-18">
                                                    해외지사
                                                </p>
                                            </div>
                                        </div>
                                    </v-col>
                                    <v-col cols="6" sm="4" class="mt-18 mt-sm-0">
                                        <div class="icon-img-box-wrap w-100" data-aos="fade-right" data-aos-delay="400">
                                            <div class="icon-img-box">
                                                <v-img src="/images/main/company-icon3.svg" max-width="37" class="icon-img-box__icon icon-img-box__icon--on"></v-img>
                                                <v-img src="/images/main/company-icon3-dark.svg" max-width="37" class="d-none d-lg-block icon-img-box__icon icon-img-box__icon--dark"></v-img>
                                                <div class="image w-100">
                                                    <img src="/images/main/company-img3.png" alt="" class="d-block w-100">
                                                </div>
                                            </div>
                                            <div class="count-txt mt-n34 px-16 px-md-26 w-100 text-right">
                                                <h2 class="font-size-32 font-size-md-46 font-size-lg-60 line-height-1 font-weight-bold color-point mb-6 mb-lg-10">
                                                    10+
                                                </h2>
                                                <p class="font-size-14 font-size-lg-18">
                                                    국내지사
                                                </p>
                                            </div>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>
            </div>

            <div class="fullpage-section fullpage-section--client">
                <div class="fullpage-inner">
                    <v-container>
                        <h4 class="mb-50 mb-lg-84 font-size-22 font-size-lg-36 font-weight-thin line-height-13 color-white text-center">
                            다양한 글로벌 기업들이 <br class="d-none d-md-block">
                            <strong class="font-weight-bold">세일즈웍스의 서비스를 경험</strong>하였습니다.
                        </h4>

                        <div class="mb-40 mb-lg-84">
                            <v-row no-gutters>
                                <v-col cols="6" sm="4" class="text-center px-16">
                                    <p class="color-white font-weight-bold font-size-18 font-size-lg-22 mb-12 mb-lg-30" data-aos="fade-down">
                                        고객사
                                    </p>
                                    <h2 class="color-point font-size-40 font-size-md-54 font-size-lg-80 line-height-1" data-aos="fade-up">
                                        150+
                                    </h2>
                                </v-col>
                                <v-col cols="6" sm="4" class="text-center px-16">
                                    <p class="color-white font-weight-bold font-size-18 font-size-lg-22 mb-12 mb-lg-30" data-aos="fade-down">
                                        브랜드 홍보대사
                                    </p>
                                    <h2 class="color-point font-size-40 font-size-md-54 font-size-lg-80 line-height-1" data-aos="fade-up">
                                        4300+
                                    </h2>
                                </v-col>
                                <v-col cols="12" sm="4" class="text-center px-16 mt-18 mt-sm-0">
                                    <p class="color-white font-weight-bold font-size-18 font-size-lg-22 mb-12 mb-lg-30" data-aos="fade-down">
                                        펀드레이저
                                    </p>
                                    <h2 class="color-point font-size-40 font-size-md-54 font-size-lg-80 line-height-1" data-aos="fade-up">
                                        2800+
                                    </h2>
                                </v-col>
                            </v-row>
                        </div>

                        <v-row no-gutters>
                            <v-col cols="12" md="6">
                                <a href="/ambassador" class="banner-link">
                                    <div class="banner-link-inner d-flex flex-column justify-center px-20 px-md-40 px-xl-60" style="background-image: url(/images/main/client-img1.png);">
                                        <h4 class="mb-8 mb-lg-18 font-size-22 font-size-lg-36 font-weight-bold line-height-1 color-point">
                                            브랜드 홍보대사
                                        </h4>
                                        <p class="font-size-14 font-size-lg-18">
                                            최고의 브랜드 경험을 선사하는 <br>
                                            브랜드 홍보대사 알아보기
                                        </p>
                                    </div>
                                    <div class="banner-link-button-wrap">
                                        <button class="banner-link-button">
                                            <span></span>
                                        </button>
                                    </div>
                                </a>
                            </v-col>
                            <v-col cols="12" md="6">
                                <a href="/fund-laser" class="banner-link banner-link--mint">
                                    <div class="banner-link-inner d-flex flex-column justify-center px-20 px-md-40 px-xl-60" style="background-image: url(/images/main/client-img2.png);">
                                        <h4 class="mb-8 mb-lg-18 font-size-22 font-size-lg-36 font-weight-bold line-height-1 color-secondary">
                                            펀드레이저
                                        </h4>
                                        <p class="font-size-14 font-size-lg-18">
                                            같이의 가치를 전달하는 <br>
                                            펀드레이저 알아보기
                                        </p>
                                    </div>
                                    <div class="banner-link-button-wrap">
                                        <button class="banner-link-button banner-link-button-white">
                                            <span></span>
                                        </button>
                                    </div>
                                </a>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>
            </div>

            <div class="fullpage-section fullpage-section--vision">
                <div class="fullpage-inner">
                    <v-container>
                        <v-row no-gutters>
                            <v-col cols="12" lg="4" class="pr-lg-36 mb-38 mb-lg-0">
                                <v-img src="/images/supportworks-symbol.svg" class="mb-20 mb-lg-54 w-120px w-lg-200px"></v-img>
                                <h4 class="color-white font-size-22 font-size-lg-36 font-weight-bold line-height-1 mb-8 mb-lg-18">
                                    서포트웍스
                                </h4>
                                <p class="color-grey-d font-size-14 font-size-lg-18">
                                    서포트웍스는 글로벌 기업 세일즈웍스의 <br class="d-none d-lg-block">
                                    펀드레이징 전문 브랜드입니다.
                                </p>
                            </v-col>
                            <v-col cols="12" lg="8">
                                <div class="px-30 px-sm-0">
                                    <v-row no-gutters class="color-white">
                                        <v-col cols="12" sm="6" md="4" offset-md="8" data-aos="fade-down" class="mb-18 mb-sm-0">
                                            <div class="box-link-wrap">
                                                <div class="box-link box-link-border">
                                                    <div class="box-link-inner">
                                                        <h4 class="font-size-18 font-size-lg-26 font-weight-bold line-height-14">
                                                            전문 펀드레이저의 <br class="d-none d-lg-block">
                                                            대면 모금
                                                        </h4>
                                                    </div>
                                                    <button class="box-link-button">
                                                        <p class="font-size-12 font-size-lg-14 mr-4 mr-lg-6">More view</p>
                                                        <span></span>
                                                    </button>
                                                </div>
                                                <div class="box-link-hover pa-20">
                                                    <h4 class="font-size-18 font-size-xl-22 font-weight-bold line-height-14 mb-6">
                                                        전문 펀드레이저의 대면 모금
                                                    </h4>
                                                    <p class="font-size-14 font-size-xl-18">
                                                        인성과 전문성, 책임감을 갖춘 펀드레이저의 캠페인 진행. <br>
                                                        1:1 대면 커뮤니케이션으로 NGO의 가치와 정확한 정보를 전달, 신뢰감을 형성
                                                    </p>
                                                </div>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4" data-aos="fade-left" data-aos-delay="600" class="mb-18 mb-sm-0">
                                            <div class="box-link-wrap">
                                                <div class="box-link box-link-bg">
                                                    <div class="box-link-inner">
                                                        <h4 class="font-size-18 font-size-lg-26 font-weight-bold line-height-14">
                                                            모금 캠페인 <br class="d-none d-lg-block">
                                                            기획&컨설팅
                                                        </h4>
                                                    </div>
                                                    <button class="box-link-button">
                                                        <p class="font-size-12 font-size-lg-14 mr-4 mr-lg-6">More view</p>
                                                        <span></span>
                                                    </button>
                                                </div>
                                                <div class="box-link-hover pa-20">
                                                    <h4 class="font-size-18 font-size-xl-22 font-weight-bold line-height-14 mb-6">
                                                        모금 캠페인 기획&컨설팅
                                                    </h4>
                                                    <p class="font-size-14 font-size-xl-18">
                                                        NGO 사업에 대한 깊은 이해를 바탕으로 효과적이고 전략적인 모금 캠페인을 기획 및 컨설팅하며 건강한 기부문화를 확산
                                                    </p>
                                                </div>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4" data-aos="fade-left" data-aos-delay="400" class="mb-18 mb-sm-0">
                                            <div class="box-link-wrap">
                                                <div class="box-link box-link-border">
                                                    <div class="box-link-inner">
                                                        <h4 class="font-size-18 font-size-lg-26 font-weight-bold line-height-14">
                                                            체계적인 통합 관리 <br class="d-none d-lg-block">
                                                            프로세스
                                                        </h4>
                                                    </div>
                                                    <button class="box-link-button">
                                                        <p class="font-size-12 font-size-lg-14 mr-4 mr-lg-6">More view</p>
                                                        <span></span>
                                                    </button>
                                                </div>
                                                <div class="box-link-hover pa-20">
                                                    <h4 class="font-size-18 font-size-xl-22 font-weight-bold line-height-14 mb-6">
                                                        체계적인 통합 관리 프로세스
                                                    </h4>
                                                    <p class="font-size-14 font-size-xl-18">
                                                        데이터 관리 및 분석, 고객지원 등 전담 부서가 단계별로 서포트. <br>
                                                        캠페인의 시작부터 끝까지 전 과정을 체계적으로 분석 및 관리
                                                    </p>
                                                </div>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4" data-aos="fade-left" data-aos-delay="200">
                                            <div class="box-link-wrap">
                                                <div class="box-link box-link-bg">
                                                    <div class="box-link-inner">
                                                        <h4 class="font-size-18 font-size-lg-26 font-weight-bold line-height-14">
                                                            아시아 8개 국가의 <br class="d-none d-lg-block">
                                                            국제적 노하우
                                                        </h4>
                                                    </div>
                                                    <button class="box-link-button">
                                                        <p class="font-size-12 font-size-lg-14 mr-4 mr-lg-6">More view</p>
                                                        <span></span>
                                                    </button>
                                                </div>
                                                <div class="box-link-hover pa-20">
                                                    <h4 class="font-size-18 font-size-xl-22 font-weight-bold line-height-14 mb-6">
                                                        아시아 8개 국가의 국제적 노하우
                                                    </h4>
                                                    <p class="font-size-14 font-size-xl-18">
                                                        아시아 전역 다양한 국가의 NGO 단체 경험과 25년 이상의 누적 데이터 보유. <br>
                                                        8개국 지사가 공유하는 펀드레이징 교육과정과 체계적인 모금 관리 시스템
                                                    </p>
                                                </div>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>
            </div>

            <div class="fullpage-section fullpage-section--live">
                <div class="fullpage-inner">
                    <v-container>
                        <div class="mb-20 mb-lg-60">
                            <v-row>
                                <v-col cols="12" md="6">
                                    <div class="mb-50">
                                        <h2 class="font-size-32 font-size-md-46 font-size-lg-60 font-weight-bold line-height-1" data-aos="fade-down">
                                            세일즈웍스 <span class="color-point">LIVE</span>
                                        </h2>
                                        <p class="color-grey-3 mt-8 mt-lg-20 font-size-14 font-size-lg-18" data-aos="fade-up">
                                            세일즈웍스의 다양한 소식을 <br class="d-none d-md-block">
                                            SNS를 통해 만나보세요.
                                        </p>
                                    </div>
                                    <div class="d-flex">
                                        <a href="https://blog.naver.com/salesworkskorea" target="_blank" class="sns sns--blog mr-6 mr-lg-12"></a>
                                        <a href="https://www.instagram.com/salesworkskorea" target="_blank" class="sns sns--instar mr-6 mr-lg-12"></a>
                                        <a href="https://www.youtube.com/c/salesworkskorea" target="_blank" class="sns sns--youtube mr-6 mr-lg-12"></a>
                                        <a href="https://www.facebook.com/salesworkskr" target="_blank" class="sns sns--facebook"></a>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="6" class="mt-18 mt-md-0">
                                    <div class="video-wrap">
                                        <youtube :video-id="videoId" />
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                        <div class="row justify-center row-cols-3 row-cols-md-5 ma-n6 ma-lg-n18">
                            <div v-for="img, idx in mainImgs" :key="idx"  class="pa-6 pa-lg-18">
                                <div class="live-thum-wrap">
                                    <div class="live-thum" style="background-image">
                                        <a :href="img.meta.href" target="_blank">
                                            <v-img :src="img?.thumb"/>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-container>
                </div>
            </div>

            <main-footer class="fullpage-section fp-auto-height"></main-footer>

        </full-page>

        <u-scroll-top-full-page></u-scroll-top-full-page>

        <popup-layer></popup-layer>

    </client-page-full-page>
</template>

<script>
import api from '@/api';
import urlParser from "js-video-url-parser";
import Swiper from "swiper/bundle";
import ClientPageFullPage from "@/pages/client/templates/ClientPage-FullPage.vue";
// import BoardList from "@/components/client/board/board-list.vue";
import PopupLayer from '@/components/client/popup/popup-layer.vue';
import MainFooter from "@/components/client/inc/main-footer.vue";
import UScrollTopFullPage from "@/components/dumb/u-scroll-top-full-page.vue";
import { BOARD_YOUTUBE_CATEGORIES, BOARD_REPORT_CATEGORIES, BOARD_FORMS_CATEGORIES } from '@/assets/variables';


const categoriesYoutube = Object.values(BOARD_YOUTUBE_CATEGORIES)
const categoriesReport = Object.values(BOARD_REPORT_CATEGORIES)
const categoriesForms = Object.values(BOARD_FORMS_CATEGORIES)

export default {
    components: {
        ClientPageFullPage,
        // BoardList,
        PopupLayer,
        MainFooter,
        UScrollTopFullPage,
    },
    props: {
        isMain: { type: Boolean, default: true },
    },
    data() {
        return {
            mainImgs: [],

            mainVisual1Poster: null,
            mainVisual1Url: null,

            mainVisual2Poster: null,
            mainVisual2Url: null,

            mainVisual3Poster: null,
            mainVisual3Url: null,

            mainVisual4Poster: null,
            mainVisual4Url: null,

            mainVideo: "",
            videoId: "",
            options: {
                navigation: true,
                animateAnchor: false,
                anchors: ['Main', 'Service', 'AboutUs', 'Clients', 'Brand', 'Live', 'Footer'],
                sectionSelector: '.fullpage-section',
                fitToSection: true,
                scrollingSpeed: 600,
                responsiveWidth: 1200,
                responsiveHeight: 750,
                easingcss3: 'ease-in-out',
                licenseKey: 'BE202675-E3234C07-967F61A1-57A110B1',
                onLeave: this.onLeave,
                onSlideLeave: this.onSlideLeave,
                afterLoad: this.afterLoad,
                afterSlideLoad:this.afterSlideLoad,
            },
            categoriesYoutube,
            categoriesReport,
            categoriesForms,
        }
    },
    mounted() {
        this.init();
    },    
    methods: {
        async init() {
            let { boards } = await api.v1.boards.gets({ headers:{ sort: "priority" }, params: { code: "visual"}});
                this.mainVisual1Poster = boards[0]?.thumb
                this.mainVisual1Url = boards[0].files[0]?.url

                this.mainVisual2Poster = boards[1]?.thumb
                this.mainVisual2Url = boards[1].files[0]?.url

                this.mainVisual3Poster = boards[2]?.thumb
                this.mainVisual3Url = boards[2].files[0]?.url

                this.mainVisual4Poster = boards[3]?.thumb
                this.mainVisual4Url = boards[3].files[0]?.url

                let imgs = await api.v1.boards.gets({ params: { code: "mainBoard"}});
                this.mainImgs = imgs.boards;

                let video = await api.v1.boards.gets({ params: { code: "mainViedo"}});
                this.mainVideo = video.boards[0].meta;

                this.videoId = urlParser.parse(this.mainVideo?.youtube)?.id || "";
                
            var bullet = ['기업소개', '사업소개', '브랜드 홍보대사 ', '펀드레이저'];
            this.$nextTick(() => {
                this.Visual = new Swiper(".visual .swiper-container", {
                    effect: "fade",
                    allowTouchMove: true,
                    centeredSlides: true,
                    spaceBetween: 0,
                    autoplay: {
                        delay: 10000,
                        disableOnInteraction: false,
                    },
                    speed: 500,
                    loop: true,
                    pagination: {
                        el: '.visual-pagination',
                        clickable: true,
                        renderBullet: function (index, className) {
                            return '<div class="' + className + '"><span>' + (bullet[index]) + '</span></div>';
                        },
                    },
                    on: {
                        slideChangeTransitionStart: function(){
                            var videos = document.querySelectorAll('video');
                            Array.prototype.forEach.call(videos, function(video){
                                video.currentTime = 0;
                            });
                        },
                        slideChangeTransitionEnd: function(){
                            var activeIndex = this.activeIndex;
                            var activeSlide = document.getElementsByClassName('swiper-slide')[activeIndex];
                            var activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
                            activeSlideVideo.play();
                        },
                    },
                });

                this.Servise = new Swiper('.service-slide .swiper-container', {
                    spaceBetween: 12,
                    slidesPerView: 1.2,
                    speed: 500,
                    loop: true,
                    centeredSlides: true,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    breakpoints: {
                        768:{
                            slidesPerView: 3,
                            spaceBetween: -12,
                        },
                        1200:{
                            slidesPerView: 3,
                            spaceBetween: -34,
                            navigation: {
                                prevEl: '.service-slide .slide-btn-prev',
                                nextEl: '.service-slide .slide-btn-next',
                            },
                        },
                    },
                });
            });

            },

            // fullpage
            onLeave: function(){
                var fpActive = document.querySelector('.fp-section.active');
                var fpAos = fpActive.querySelectorAll('.aos-init');
                fpAos.forEach((item) => {
                    item.classList.remove('aos-animate');
                });
            },
            onSlideLeave: function(){
                var fpActive = document.querySelector('.fp-section.active');
                var fpAos = fpActive.querySelectorAll('.aos-init');
                fpAos.forEach((item) => {
                    item.classList.remove('aos-animate');
                });
            },
            afterLoad: function(origin, destination, direction){
                var fpActive = document.querySelector('.fp-section.active');
                var fpAos = fpActive.querySelectorAll('.aos-init');
                fpAos.forEach((item) => {
                    item.classList.add('aos-animate');
                });
            },
            afterSlideLoad: function(){
                var fpActive = document.querySelector('.fp-section.active');
                var fpAos = fpActive.querySelectorAll('.aos-init');
                fpAos.forEach((item) => {
                    item.classList.add('aos-animate');
                });
            },

        },
};
</script>

<style scoped>

.visual{
    position: relative;
    overflow: hidden;
}

.visual .swiper-container{
    width: 100%;
    height: 100vh
}

.visual .swiper-wrapper, .visual .swiper-slide{
    height: 100%;
}

.swiper-slide__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -2;
}

.swiper-slide__bg::after{
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}

.swiper-slide__bg__image{
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    transform: scale(1.15);
}

.visual .swiper-slide.swiper-slide-active .swiper-slide__bg__image{
    animation: scale 9.5s ease-out forwards;
}

@keyframes scale {
    0%{
        transform: scale(1);
    }
    100%{
        transform: scale(1.15);
    }
}

.swiper-slide__bg__video{
    position: absolute;
    left: 0;
    bottom: 0;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.visual__con {
    position: relative;
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
    max-width: calc(var(--container) + 12px*2);
    padding: 0 12px;
    margin: auto;
    color: #fff;
}

.visual__con h2{
    font-size: 3.2rem;
    font-weight: 700;
    line-height: 42px;
}

.visual-pagination{
    width: 100%;
    max-width: 824px;
    display: flex;
}

@media (min-width:576px){
}
@media (min-width:768px){
    .visual__con h2{
        font-size: 4.6rem;
        line-height: 60px;
    }
}
@media (min-width:1024px){
    .visual__con h2{
        font-size: 6rem;
        line-height: 76px;
    }
}
@media (min-width:1200px){
}


</style>